import Record from './record-sdk'
import utils from '../../utils/utils'
import {Message} from 'element-ui'
const {voiceTime} = require('../../../static/config.js')

let startInterval = null
let startSecond = 0// 正在录音的时长
// eslint-disable-next-line no-unused-vars
// let voiceTime = 0// 录音时长
let recorder = new Record()

export default {
  // 开始录音
  onStartVoice: function (callback) {
    // this.onStopAudio()
    recorder.startRecord({
      success: res => {
        startSecond = 0
        if (startInterval) {
          clearInterval(startInterval)
          startInterval = null
        }
        // 改变页面录音时长
        startInterval = setInterval((function target () {
          // eslint-disable-next-line standard/no-callback-literal
          callback(voiceTime - ++startSecond)
          //   if (startSecond >= window.g.voiceTime) {
          //     clearInterval(startInterval)
          //     startInterval = null
          //   }
          return target
        })(), 1000)
      },
      error: e => {
        Message.error(e)
      }
    })
  },
  // 结束录音并处理返回录音
  onEndVoice: function (callback) {
    if (startInterval) {
      clearInterval(startInterval)
      startInterval = null
    //   voiceTime = startSecond
    }
    recorder.stopRecord({
      success: res => {
        // 此处可以获取音频源文件(res)，用于上传等操作
        utils.blobToBase64(res).then(val => {
          let params = {
            Data: val,
            Time: startSecond
          }
          callback(params)
        })
      },
      error: e => {
        Message.error(e)
      }
    })
  },
  // 结束录音
  stop: function () {
    recorder.stop()
  },
  // 清除录音
  onStopAudio: function () {
    this.recorder.clear(this.audio)
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/libs/recordUtils/voice-utils.js
// module id = null
// module chunks = 